import {
	find,
	some
} from "lodash";
import moment from "moment-timezone";
import { FORM_TIMEZONE_TYPES } from "../constants";
import {
	EDIT_REPORT,
	NEW_REPORT
} from "../routes";


//%*0115107629*Y19*SDO1039184?
class CardSwipeService {
	constructor($uibModal, appState, reportHelper, auth, $state) {
		this.$uibModal = $uibModal;
		this.appState = appState;
		this.reportHelper = reportHelper;
		this.auth = auth;
		this.$state = $state;

		this.NEW_REPORT = NEW_REPORT;
	}

	$onInit() {

	}

	initializeCardSwipe() {
		const instance = this.$uibModal.open({
			component: "card-swipe-modal",
			size: "md",
			backdrop: "static",
			resolve: {
				formConfig: () => this.appState.forms.selected
			}
		});

		instance.result
			.then((cardInfo) => {
				const updates = this.createCardSwipeReport(cardInfo);
				this.reportHelper.saveReport(this.appState.forms.selected.Id, updates).then((resp) => {
					this.$state.go(EDIT_REPORT, { id: resp.Id });
				});
			})
			.finally(() => {
				this.selectedDetail = undefined;
				this.form.detailFields.map(f => f.isLocked = false);
			});
	}

	createCardSwipeReport(cardInfo) {
		const updates = cardInfo.map(i => {
			const update = {
				FieldId: i.fieldId,
				EntityId: i.value
			};

			if(i.isDetail) {
				update["DetailLinkKey"] = this.auth.uuid();
			}

			return update;
		});

		let timeZone = null;

		if(this.appState.forms.selected.TimeMode.Code === FORM_TIMEZONE_TYPES.ByForm) {
			timeZone = this.appState.forms.selected.TimeZone.Code;
		}
		else if(this.appState.forms.selected.TimeMode.Code === FORM_TIMEZONE_TYPES.ByEntity) {
			const primaryEntityField = find(this.appState.forms.selected.Fields, (field) => {
				return (field.Type.Code === "ENTITY" || field.Type.Code === "ENTITYCONTACT") && field.IsPrimary === true;
			});
			const selectedPrimaryEntityValue = find(updates, u => u.FieldId === primaryEntityField.Id);

			if(selectedPrimaryEntityValue) {
				const selectedPrimaryEntity = find(primaryEntityField, f => (f.Id === selectedPrimaryEntityValue.EntityId)
					|| (some(f.Entities, e => e.Entity.Id === selectedPrimaryEntityValue.EntityId)));
				timeZone = selectedPrimaryEntity.TimeZone.Code;
			}
		}

		let now = moment().startOf("day")
			.local()
			.format();

		if(timeZone) {
			now = moment().startOf("day")
				.tz(timeZone)
				.format();
		}

		const primaryDateField = find(this.appState.forms.selected.Fields, (field) => field.Template === "Date" && field.IsPrimary === true);
		updates.push(
			{
				FieldId: primaryDateField.Id,
				Date: now
			}
		);

		return updates;
	}
}

export default angular
	.module("vesl.services.card-swipe-service", [])
	.service("cardSwipeService", CardSwipeService).name;
